import { apiClient } from '../../gateways/api'
import type { FetchHoofdnetValuelists } from '../types/FetchHoofdnetValuelists'

export { fetchHoofdnetValuelists, initialState }

const initialState: FetchHoofdnetValuelists = {
  data: {
    opdrachtgevers: [],
    opdrachtnemers: [],
    types: [],
    disciplines: [],
    versies: [],
  },
}

const fetchHoofdnetValuelists = async (): Promise<
  FetchHoofdnetValuelists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/valuelist/hoofdnet',
    method: 'GET',
  })
  return data
}
